import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '15ch',
      '& .MuiInputBase-root': {
        color: '#000',
        '&::before': {
          borderBottom: '1px solid #BDBDBD'
        }
      },
      '& .MuiInput-underline:after': {
        borderBottom: 'none'
      },
      '& .Mui-disabled': {
        color: '#BDBDBD'
      },
      '& .MuiInput-root': {
        fontSize: '14px',
        // fontFamily: '\'Roboto\', sans-serif'
        fontFamily: '\'DIN Pro Light\''
      }
    }
  },
  menuItemRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '14px'
    }
  }
}))

export default function Select(props) {
  const options = props.selectOptions
  const classes = useStyles()
  const [value, setValue] = React.useState(props.defaultOption)

  const handleChange = event => {
    setValue(event.target.value)
    props.handleSelect(event.target.value)
  }

  return (
    <div className={classes.root} data-testid="select">
      <TextField
        id="layout-selection"
        select
        value={value}
        onChange={handleChange}
        inputProps={{ 'data-testid': `select-text-field_${props.index}` }}
        disabled={props.disabled}
      >
        {options.map(option => (
          <MenuItem data-testid={option.label} className={classes.menuItemRoot} key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  )
}

Select.propTypes = {
  index: PropTypes.number,
  disabled: PropTypes.bool,
  selectOptions: PropTypes.array,
  defaultOption: PropTypes.string,
  handleSelect: PropTypes.func
}
